var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.params.class,on:{"click":function($event){return _vm.params.clickFunction(_vm.params.data.id)}}},[_vm._v("\n  "+_vm._s(_vm.params.buttonName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }